const STORAGE_KEY = "superadmin_report_location_filters_v1";

export const SUPERADMIN_REPORT_LOCATION_FILTER_DEFAULTS = {
  enabled: false,
  city: "",
  province: "",
  postal_code: "",
  country: "",
};

function normalizeValue(value) {
  return typeof value === "string" ? value : "";
}

function normalizeFilters(value) {
  const hasStoredEnabled = typeof value?.enabled === "boolean";
  const hasLocationValue = Boolean(
    normalizeValue(value?.city).trim() ||
      normalizeValue(value?.province).trim() ||
      normalizeValue(value?.postal_code).trim() ||
      normalizeValue(value?.country).trim()
  );
  return {
    enabled: hasStoredEnabled ? value.enabled : hasLocationValue,
    city: normalizeValue(value?.city).trim(),
    province: normalizeValue(value?.province).trim(),
    postal_code: normalizeValue(value?.postal_code).trim(),
    country: normalizeValue(value?.country).trim(),
  };
}

export function getStoredSuperAdminReportLocationFilters() {
  if (typeof window === "undefined") {
    return { ...SUPERADMIN_REPORT_LOCATION_FILTER_DEFAULTS };
  }
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...SUPERADMIN_REPORT_LOCATION_FILTER_DEFAULTS };
    return normalizeFilters(JSON.parse(raw));
  } catch (error) {
    return { ...SUPERADMIN_REPORT_LOCATION_FILTER_DEFAULTS };
  }
}

export function setStoredSuperAdminReportLocationFilters(value) {
  const normalized = normalizeFilters(value);
  if (typeof window !== "undefined") {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    } catch (error) {
      // Ignore storage failures and still return the normalized value.
    }
  }
  return normalized;
}

export function appendSuperAdminReportLocationFilters(query, value) {
  const normalized = normalizeFilters(
    value || getStoredSuperAdminReportLocationFilters()
  );
  if (!normalized.enabled) return query;
  if (normalized.city) query.set("city", normalized.city);
  if (normalized.province) query.set("province", normalized.province);
  if (normalized.postal_code) query.set("postal_code", normalized.postal_code);
  if (normalized.country) query.set("country", normalized.country);
  return query;
}

export function withSuperAdminReportLocationFilters(payload = {}, value) {
  const normalized = normalizeFilters(
    value || getStoredSuperAdminReportLocationFilters()
  );
  if (!normalized.enabled) {
    return {
      ...payload,
      city: undefined,
      province: undefined,
      postal_code: undefined,
      country: undefined,
    };
  }
  return {
    ...payload,
    city: normalized.city || undefined,
    province: normalized.province || undefined,
    postal_code: normalized.postal_code || undefined,
    country: normalized.country || undefined,
  };
}
